import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { SharetribeApi, transactionLineItems } from '../../util/api';
import * as log from '../../util/log';
import {
  denormalisedEntities,
  denormalisedResponseEntities,
  updatedEntities,
} from '../../util/data';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import {
  getUserDirectMessageServices,
  getUserSubscriptionLookupkeys,
  getUserType,
} from '../../util/userDataExtraction';
import { entityRefs, isArrayLength } from '../../util/genericHelpers';
import { clearSubscriptionPrices, retrieveSubscriptionPrice } from '../../ducks/stripe.duck';
import { StatusCode, UserType } from '../../util/enums';
import { getBrandListingsQueryParams, getListingCategory } from '../../util/listingPageHelpers';
import {
  BULK_JOB_POST,
  CAMPAIGN,
  JOB_POST,
  PERKS,
  PLUS,
  PREMIER,
  REWARD,
  SINGLE_JOB_POST,
} from '../../util/constants';
import { showErrorToast, showSuccessToast } from '../../util/toast';
import { deleteListingSessionUrl } from '../../util/helperFunction';
import { getListingAssociatedUsers } from '../../util/listingDataExtraction';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const FETCH_PERKS_LISTINGS_REQUEST = 'app/ListingPage/FETCH_PERKS_LISTINGS_REQUEST';
export const FETCH_PERKS_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_PERKS_LISTINGS_SUCCESS';
export const FETCH_PERKS_LISTINGS_ERROR = 'app/ListingPage/FETCH_PERKS_LISTINGS_ERROR';

export const FETCH_CAMPAIGN_LISTINGS_REQUEST = 'app/ListingPage/FETCH_CAMPAIGN_LISTINGS_REQUEST';
export const FETCH_CAMPAIGN_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_CAMPAIGN_LISTINGS_SUCCESS';
export const FETCH_CAMPAIGN_LISTINGS_ERROR = 'app/ListingPage/FETCH_CAMPAIGN_LISTINGS_ERROR';

export const FETCH_REWARD_LISTINGS_REQUEST = 'app/ListingPage/FETCH_REWARD_LISTINGS_REQUEST';
export const FETCH_REWARD_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_REWARD_LISTINGS_SUCCESS';
export const FETCH_REWARD_LISTINGS_ERROR = 'app/ListingPage/FETCH_REWARD_LISTINGS_ERROR';

export const FETCH_SINGLE_JOBS_LISTINGS_REQUEST =
  'app/ListingPage/FETCH_SINGLE_JOBS_LISTINGS_REQUEST';
export const FETCH_SINGLE_JOBS_LISTINGS_SUCCESS =
  'app/ListingPage/FETCH_SINGLE_JOBS_LISTINGS_SUCCESS';
export const FETCH_SINGLE_JOBS_LISTINGS_ERROR = 'app/ListingPage/FETCH_SINGLE_JOBS_LISTINGS_ERROR';

export const FETCH_BULK_JOBS_LISTINGS_REQUEST = 'app/ListingPage/FETCH_BULK_JOBS_LISTINGS_REQUEST';
export const FETCH_BULK_JOBS_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_BULK_JOBS_LISTINGS_SUCCESS';
export const FETCH_BULK_JOBS_LISTINGS_ERROR = 'app/ListingPage/FETCH_BULK_JOBS_LISTINGS_ERROR';

export const CLOSE_LISTING_REQUEST = 'app/ListingPage/CLOSE_LISTING_REQUEST';
export const CLOSE_LISTING_SUCCESS = 'app/ListingPage/CLOSE_LISTING_SUCCESS';
export const CLOSE_LISTING_ERROR = 'app/ListingPage/CLOSE_LISTING_ERROR';

export const FETCH_OWN_TALENT_LISTINGS_REQUEST =
  'app/ListingPage/FETCH_OWN_TALENT_LISTINGS_REQUEST';
export const FETCH_OWN_TALENT_LISTINGS_SUCCESS =
  'app/ListingPage/FETCH_OWN_TALENT_LISTINGS_SUCCESS';
export const FETCH_OWN_TALENT_LISTINGS_ERROR = 'app/ListingPage/FETCH_OWN_TALENT_LISTINGS_ERROR';

export const FETCH_DIRECT_MESSAGE_TRANSACTION_REQUEST =
  'app/ListingPage/FETCH_DIRECT_MESSAGE_TRANSACTION_REQUEST';
export const FETCH_DIRECT_MESSAGE_TRANSACTION_SUCCESS =
  'app/ListingPage/FETCH_DIRECT_MESSAGE_TRANSACTION_SUCCESS';
export const FETCH_DIRECT_MESSAGE_TRANSACTION_ERROR =
  'app/ListingPage/FETCH_DIRECT_MESSAGE_TRANSACTION_ERROR';

// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  fetchPerksListingsInProgress: false,
  fetchPerksListingsError: null,
  perksListings: [],
  fetchJobsListingsInProgress: false,
  fetchJobsListingsError: null,
  singleJobListings: [],
  bulkJobListings: [],
  fetchCampaignListingsInProgress: false,
  fetchCampaignListingsError: null,
  campaignListings: [],
  fetchRewardListingsInProgress: false,
  fetchRewardListingsError: null,
  rewardListings: [],
  closeListingInProgressId: null,
  closeListingError: null,
  directChatTransactionId: null,
  fetchDirectMessageTransactionInProgress: false,
  fetchDirectMessageTransactionError: null,
  fetchOwnTalentListingsInProgress: false,
  fetchOwnTalentListingsError: null,
  ownTalentListings: [],
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };

    case FETCH_PERKS_LISTINGS_REQUEST:
      return { ...state, fetchPerksListingsInProgress: true, fetchPerksListingsError: null };
    case FETCH_PERKS_LISTINGS_SUCCESS:
      return { ...state, fetchPerksListingsInProgress: false, perksListings: payload };
    case FETCH_PERKS_LISTINGS_ERROR:
      return { ...state, fetchPerksListingsInProgress: false, fetchPerksListingsError: payload };

    case FETCH_SINGLE_JOBS_LISTINGS_REQUEST:
      return { ...state, fetchJobsListingsInProgress: true, fetchJobsListingsError: null };
    case FETCH_SINGLE_JOBS_LISTINGS_SUCCESS:
      return { ...state, fetchJobsListingsInProgress: false, singleJobListings: payload };
    case FETCH_SINGLE_JOBS_LISTINGS_ERROR:
      return { ...state, fetchJobsListingsInProgress: false, fetchJobsListingsError: payload };

    case FETCH_BULK_JOBS_LISTINGS_REQUEST:
      return { ...state, fetchJobsListingsInProgress: true, fetchJobsListingsError: null };
    case FETCH_BULK_JOBS_LISTINGS_SUCCESS:
      return { ...state, fetchJobsListingsInProgress: false, bulkJobListings: payload };
    case FETCH_BULK_JOBS_LISTINGS_ERROR:
      return { ...state, fetchJobsListingsInProgress: false, fetchJobsListingsError: payload };
    case FETCH_CAMPAIGN_LISTINGS_REQUEST:
      return { ...state, fetchCampaignListingsInProgress: true, fetchCampaignListingsError: null };
    case FETCH_CAMPAIGN_LISTINGS_SUCCESS:
      return { ...state, fetchCampaignListingsInProgress: false, campaignListings: payload };
    case FETCH_CAMPAIGN_LISTINGS_ERROR:
      return {
        ...state,
        fetchCampaignListingsInProgress: false,
        fetchCampaignListingsError: payload,
      };
    case FETCH_REWARD_LISTINGS_REQUEST:
      return { ...state, fetchRewardListingsInProgress: true, fetchRewardListingsError: null };
    case FETCH_REWARD_LISTINGS_SUCCESS:
      return { ...state, fetchRewardListingsInProgress: false, rewardListings: payload };
    case FETCH_REWARD_LISTINGS_ERROR:
      return {
        ...state,
        fetchRewardListingsInProgress: false,
        fetchRewardListingsError: payload,
      };
    case CLOSE_LISTING_REQUEST:
      return {
        ...state,
        closeListingInProgressId: payload.listingId,
        closeListingError: null,
      };
    case CLOSE_LISTING_SUCCESS: {
      const { categorySuffix, listingId } = payload;

      const listKey = {
        [PERKS]: 'perksListings',
        [JOB_POST]: 'jobsListings',
        [CAMPAIGN]: 'campaignListings',
        [REWARD]: 'rewardListings',
      }[categorySuffix];

      // If we don’t recognize the suffix, bail out
      if (!listKey) return state;

      return {
        ...state,
        [listKey]: state[listKey].filter(listing => listing.id.uuid !== listingId),
        closeListingInProgressId: null,
        closeListingError: null,
      };
    }

    case CLOSE_LISTING_ERROR: {
      // eslint-disable-next-line no-console
      console.error(payload);
      return {
        ...state,
        closeListingInProgressId: null,
        closeListingError: payload,
      };
    }

    case FETCH_DIRECT_MESSAGE_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchDirectMessageTransactionInProgress: true,
        fetchDirectMessageTransactionError: null,
        directChatTransactionId: null,
      };

    case FETCH_DIRECT_MESSAGE_TRANSACTION_SUCCESS:
      return {
        ...state,
        fetchDirectMessageTransactionInProgress: false,
        directChatTransactionId: payload,
      };

    case FETCH_DIRECT_MESSAGE_TRANSACTION_ERROR:
      return {
        ...state,
        fetchDirectMessageTransactionInProgress: false,
        fetchDirectMessageTransactionError: payload,
        directChatTransactionId: null,
      };

    case FETCH_OWN_TALENT_LISTINGS_REQUEST:
      return {
        ...state,
        fetchOwnTalentListingsInProgress: true,
        fetchOwnTalentListingsError: null,
      };
    case FETCH_OWN_TALENT_LISTINGS_SUCCESS:
      return {
        ...state,
        fetchOwnTalentListingsInProgress: false,
        ownTalentListings: payload,
      };
    case FETCH_OWN_TALENT_LISTINGS_ERROR:
      return {
        ...state,
        fetchOwnTalentListingsInProgress: false,
        fetchOwnTalentListingsError: payload,
      };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const closeListingRequest = listingId => ({
  type: CLOSE_LISTING_REQUEST,
  payload: { listingId },
});

export const closeListingSuccess = (categorySuffix, listingId) => ({
  type: CLOSE_LISTING_SUCCESS,
  payload: { categorySuffix, listingId },
});

export const closeListingError = e => ({
  type: CLOSE_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const fetchPerksListingsRequest = () => ({ type: FETCH_PERKS_LISTINGS_REQUEST });
export const fetchBrandListingsSuccess = data => ({
  type: FETCH_PERKS_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchPerksListingsError = e => ({
  type: FETCH_PERKS_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchSingleJobsListingsRequest = () => ({ type: FETCH_SINGLE_JOBS_LISTINGS_REQUEST });
export const fetchSingleJobsListingsSuccess = data => ({
  type: FETCH_SINGLE_JOBS_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchSingleJobsListingsError = e => ({
  type: FETCH_SINGLE_JOBS_LISTINGS_REQUEST,
  error: true,
  payload: e,
});

export const fetchBulkJobsListingsRequest = () => ({ type: FETCH_BULK_JOBS_LISTINGS_REQUEST });
export const fetchBulkJobsListingsSuccess = data => ({
  type: FETCH_BULK_JOBS_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchBulkJobsListingsError = e => ({
  type: FETCH_BULK_JOBS_LISTINGS_ERROR,
  error: true,
  payload: e,
});
export const fetchCampaignListingsRequest = () => ({ type: FETCH_CAMPAIGN_LISTINGS_REQUEST });
export const fetchCampaignListingsSuccess = data => ({
  type: FETCH_CAMPAIGN_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchCampaignListingsError = e => ({
  type: FETCH_CAMPAIGN_LISTINGS_ERROR,
  error: true,
  payload: e,
});
export const fetchRewardListingsRequest = () => ({ type: FETCH_REWARD_LISTINGS_REQUEST });
export const fetchRewardListingsSuccess = data => ({
  type: FETCH_REWARD_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchRewardListingsError = e => ({
  type: FETCH_REWARD_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchDirectMessageTransactionRequest = () => ({
  type: FETCH_DIRECT_MESSAGE_TRANSACTION_REQUEST,
});

export const fetchDirectMessageTransactionSuccess = transactionId => ({
  type: FETCH_DIRECT_MESSAGE_TRANSACTION_SUCCESS,
  payload: transactionId,
});

export const fetchDirectMessageTransactionError = error => ({
  type: FETCH_DIRECT_MESSAGE_TRANSACTION_ERROR,
  payload: error,
});

export const fetchOwnTalentListingsRequest = () => ({ type: FETCH_OWN_TALENT_LISTINGS_REQUEST });
export const fetchOwnTalentListingsSuccess = data => ({
  type: FETCH_OWN_TALENT_LISTINGS_SUCCESS,
  payload: data,
});
export const fetchOwnTalentListingsError = e => ({
  type: FETCH_OWN_TALENT_LISTINGS_ERROR,
  error: true,
  payload: e,
});
// ================ Selectors ================ //
export const perksListingsSelector = state => state.ListingPage.perksListings;
export const jobsListingsSelector = state => state.ListingPage.jobsListings;

export const singleJobsListingsSelector = state => state.ListingPage.singleJobListings;
export const bulkJobsListingsSelector = state => state.ListingPage.bulkJobListings;
export const campaignListingsSelector = state => state.ListingPage.campaignListings;
export const rewardListingsSelector = state => state.ListingPage.rewardListings;

export const closeListingInProgressIdSelector = state => state.ListingPage.closeListingInProgressId;

export const directChatTransactionIdSelector = state => state.ListingPage.directChatTransactionId;
export const fetchMessageTxnInProgress = state =>
  state.ListingPage.fetchDirectMessageTransactionInProgress;

export const associatedListingsSelector = state => state.ListingPage.ownTalentListings;
// ================ Thunks ================ //

export const showListing = (listingId, config, isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'author.publicData', 'images', 'currentStock'],
    'fields.image': [
      'variants.default',
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      return response;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, message) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // TODO: visit later for message
      // Send the message to the created transaction
      // return sdk.messages.send({ transactionId, content: message }).then(() => {
      //   dispatch(sendInquirySuccess());
      //   dispatch(fetchCurrentUserHasOrdersSuccess(true));
      //   return transactionId;
      // });
      return transactionId;
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const uploadImageViaSharetribeSDK = file => async (dispatch, getState, sdk) => {
  function extractImageUrl(data) {
    if (data?.data?.data?.attributes?.variants) {
      return data.data.data.attributes.variants.default.url;
    }
    return 'https://t3.ftcdn.net/jpg/05/79/68/24/360_F_579682465_CBq4AWAFmFT1otwioF5X327rCjkVICyH.jpg'; // Return null if the necessary data is not found
  }

  try {
    const response = await sdk.images.upload(
      {
        image: file,
      },
      {
        expand: true,
      }
    );
    return extractImageUrl(response);
  } catch (error) {
    console.log(error, `Error while uploading image via Sharetribe SDK`);
  }
};

export const updateBannerImageToListing = ({ bannerImage, listingId, config }) => async (
  dispatch,
  getState,
  sdk
) => {
  try {
    const response = await sdk.ownListings.update({
      id: listingId,
      publicData: {
        bannerImage,
      },
    });

    await dispatch(showListing(listingId, config, true));

    return response;
  } catch (error) {
    console.log(error, `Error while updating banner image to listing`);
  }
};

// Generic thunk creator for fetching listings
const fetchListingsGeneric = (categorySuffix, requestAction, successAction, errorAction) => (
  authorId,
  authorType
) => async (dispatch, getState, sdk) => {
  dispatch(requestAction());
  const queryParams = getBrandListingsQueryParams();
  try {
    const response = await sdk.listings.query({
      authorId,
      pub_listingCategory: getListingCategory(categorySuffix, authorType),
      ...queryParams,
    });
    const entities = updatedEntities({}, response.data);
    const listingRefs = entityRefs(response.data.data);
    const denormalisedListings = denormalisedEntities(entities, listingRefs, false);
    dispatch(successAction(denormalisedListings));
  } catch (error) {
    dispatch(errorAction(storableError(error)));
  }
};

// Using the generic function to create specific thunks
export const fetchPerksListings = fetchListingsGeneric(
  PERKS,
  fetchPerksListingsRequest,
  fetchBrandListingsSuccess,
  fetchPerksListingsError
);

export const fetchSingleJobsListings = fetchListingsGeneric(
  SINGLE_JOB_POST,
  fetchSingleJobsListingsRequest,
  fetchSingleJobsListingsSuccess,
  fetchSingleJobsListingsError
);
export const fetchBulkJobsListings = fetchListingsGeneric(
  BULK_JOB_POST,
  fetchBulkJobsListingsRequest,
  fetchBulkJobsListingsSuccess,
  fetchBulkJobsListingsError
);
export const fetchCampaignListings = fetchListingsGeneric(
  CAMPAIGN,
  fetchCampaignListingsRequest,
  fetchCampaignListingsSuccess,
  fetchCampaignListingsError
);
export const fetchRewardListings = fetchListingsGeneric(
  REWARD,
  fetchRewardListingsRequest,
  fetchRewardListingsSuccess,
  fetchRewardListingsError
);

export const closeListing = (categorySuffix, listingId) => async (dispatch, getState, sdk) => {
  dispatch(closeListingRequest(listingId));
  try {
    const response = await sdk.ownListings.close({ id: listingId }, { expand: true });
    // Pass categorySuffix and listingId in the success payload so the reducer can remove the listing
    dispatch(closeListingSuccess(categorySuffix, listingId));
    showSuccessToast('Your listing has been closed.');
    return response;
  } catch (error) {
    dispatch(closeListingError(storableError(error)));
    showErrorToast('Error while closing listing');
    // Optionally rethrow error if further handling upstream is desired
    // throw error;
  }
};

export const fetchDirectMessageTransaction = (listingId, currentUser) => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchDirectMessageTransactionRequest());

  try {
    const directMessageServices = getUserDirectMessageServices(currentUser);
    const listingIdStr = listingId?.uuid;
    const transactionId = directMessageServices?.[listingIdStr]?.transactionId;

    if (!transactionId) {
      dispatch(fetchDirectMessageTransactionError('No transaction ID found'));
      return null;
    }

    const transactionResponse = await SharetribeApi.fetchTransactionById({
      txId: transactionId,
    });

    if (transactionResponse?.statusCode === StatusCode.SUCCESS) {
      dispatch(fetchDirectMessageTransactionSuccess(transactionResponse.data.transactionId));
      return transactionResponse.data;
    } else {
      throw new Error('Failed to fetch transaction');
    }
  } catch (error) {
    dispatch(fetchDirectMessageTransactionError(storableError(error)));
    showErrorToast('Error while fetching transaction details');
    return null;
  }
};

const fetchOwnTalentListings = ({ associatedUsers }) => async (dispatch, getState, sdk) => {
  dispatch(fetchOwnTalentListingsRequest());

  const queryParams = getBrandListingsQueryParams();
  const listingCategories = {
    [UserType.BRAND]: UserType.BRAND,
    [UserType.AGENCY]: UserType.AGENCY,
    [UserType.SCHOOL]: UserType.SCHOOL,
  };

  try {
    // Step 1: Fetch all user profiles with individual error handling
    const userProfilePromises = associatedUsers.map(async ({ email, talentId }) => {
      try {
        const {
          data: { data: user },
        } = await sdk.users.show({ id: talentId });
        const userType = getUserType(user);
        return {
          email,
          talentId,
          user,
          userType,
          success: true,
        };
      } catch (error) {
        return {
          email,
          talentId,
          success: false,
          error: error.message,
        };
      }
    });

    const userProfileResults = await Promise.all(userProfilePromises);

    // Filter only successful user fetches
    const validUserProfiles = userProfileResults.filter(result => result.success);

    // Step 2: Fetch listings for each valid user
    const listingPromises = validUserProfiles.map(async ({ email, talentId, userType }) => {
      try {
        const response = await sdk.listings.query({
          authorId: talentId,
          pub_listingCategory: listingCategories[userType],
          ...queryParams,
        });

        return {
          email,
          talentId,
          response: response,
          success: true,
        };
      } catch (error) {
        return {
          email,
          talentId,
          success: false,
          error: error.message,
        };
      }
    });

    const listingResults = await Promise.all(listingPromises);

    // Step 3: Filter successful listing fetches
    const successfulResults = listingResults.filter(result => result.success);

    // Step 4: Handle case where no listings were found
    if (successfulResults.length === 0) {
      dispatch(fetchOwnTalentListingsSuccess([]));
      return;
    }

    // Step 5: Combine all responses and create entities (keeping original logic)
    let combinedEntities = {};
    let allListingRefs = [];

    successfulResults.forEach(({ response }) => {
      // Update entities with each response
      combinedEntities = updatedEntities(combinedEntities, response.data);
      // Collect listing refs
      const refs = entityRefs(response.data.data);
      allListingRefs.push(...refs);
    });

    // Denormalise all listings
    const denormalisedListings = denormalisedEntities(combinedEntities, allListingRefs, false);
    // Step 6: Dispatch success with all listings
    dispatch(fetchOwnTalentListingsSuccess(denormalisedListings));
  } catch (error) {
    dispatch(fetchOwnTalentListingsError(storableError(error)));
  }
};
export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const listingId = new UUID(params.id);
  dispatch(clearSubscriptionPrices());
  deleteListingSessionUrl();
  // Fetch the listing details
  const listingResponse = await dispatch(showListing(listingId, config));
  const listing = listingResponse.data.data;
  const currentUser = await dispatch(fetchCurrentUser());
  const currentUserId = currentUser?.id?.uuid;

  // Extract authorId from listing relationships
  const authorId = listing?.relationships?.author?.data?.id;
  if (!authorId) {
    return;
  }

  const authorResponse = await sdk.users.show({ id: authorId });
  const author = authorResponse.data.data;
  const authorType = getUserType(author);
  const lookupKeys = getUserSubscriptionLookupkeys(author);
  if (isArrayLength(lookupKeys)) {
    await dispatch(retrieveSubscriptionPrice({ lookupKeys: [...lookupKeys] }));
  }

  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));
  if (currentUserId) {
    dispatch(fetchDirectMessageTransaction(listingId, currentUser));
  }
  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  const associatedUsers = getListingAssociatedUsers(listing);
  if (authorId && isArrayLength(associatedUsers)) {
    dispatch(fetchOwnTalentListings({ authorId, associatedUsers }));
  }
  if ([UserType.BRAND, UserType.AGENCY, UserType.SCHOOL].includes(authorType)) {
    [
      fetchPerksListings,
      fetchSingleJobsListings,
      fetchBulkJobsListings,
      fetchCampaignListings,
      fetchRewardListings,
    ].forEach(fetchAction => {
      dispatch(fetchAction(authorId, authorType));
    });
  }

  return Promise.all([dispatch(fetchReviews(listingId))]).then(() => {
    const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
    if (isBookingProcessAlias(transactionProcessAlias)) {
      // Fetch timeSlots.
      fetchMonthlyTimeSlots(dispatch, listing);
    }
  });
};
